import React from 'react';
import ManageLayout from '../components/ManageLayout';
import FamilyInfoSection from '../components/FamilyInfoSection';
import AddressSection from '../components/AddressSection';
import PersonSection from '../components/PersonSection';
import axios from 'axios';
import { API_BASE_URL } from '../lib/constants';
import { useAuthRedirect } from '../lib/useAuthRedirect';

import eventBus from '../lib/eventBus';

export default function ManagePage() {
  useAuthRedirect(`${API_BASE_URL}/api/addresses/`, localStorage.getItem('token'));
  const [addresses, setAddresses] = React.useState<any[]>([]);
  // Removed unused loading and setLoading

  const fetchAddresses = async () => {
    // Removed setLoading
    try {
      const res = await axios.get(`${API_BASE_URL}/api/addresses/`, { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });
      setAddresses(Array.isArray(res.data) ? res.data : []);
    } catch (err: any) {
      if (err.response && (err.response.status === 401 || err.response.status === 403)) {
        window.location.href = '/login';
        return;
      }
      setAddresses([]);
    } finally {
      // Clean up after fetch
    }
  };

  React.useEffect(() => {
    fetchAddresses();
    // Listen for addressesChanged event
    const unsubscribe = eventBus.on('addressesChanged', fetchAddresses);
    return () => unsubscribe();
  }, []);

  return (
    <ManageLayout>
      <div style={{ padding: 32, maxWidth: 800, margin: '0 auto' }}>
        <h1 style={{ fontSize: 28, fontWeight: 700, marginBottom: 24 }}>Family</h1>
        <FamilyInfoSection />
        <AddressSection />
        <PersonSection addresses={addresses} />
      </div>
    </ManageLayout>
  );
}
